export default __webpack_public_path__ + "static/media/bg_pengetahuan.309fd0cd.webp";